import { queryOptions } from '@tanstack/react-query';
import { pageAPIClient } from '../pageClient';
import { PAGE_QUERY_KEYS } from './keys';
import type { GetPageMetaRequest } from './types';

export const PAGE_QUERIES = {
  getPageMeta: (params: GetPageMetaRequest) =>
    queryOptions({
      queryKey: PAGE_QUERY_KEYS.meta(params.pathname, params.currency),
      queryFn: () => pageAPIClient.getPageMeta(params),
      enabled: Boolean(params.pathname),
    }),
  getCollectionDetail: (slug?: string) =>
    queryOptions({
      queryKey: PAGE_QUERY_KEYS.collectionDetail(slug),
      queryFn: () => pageAPIClient.getCollectionDetail({ slug: slug || '' }),
      enabled: Boolean(slug),
    }),
};
